import React from 'react';
var TabsSkeleton = function () { return (React.createElement("div", { className: "tabs" },
    React.createElement("ul", { className: "nav nav-tabs nav-tabs-dnvgl", role: "tablist" },
        React.createElement("li", { className: "skeleton-line skeleton-h-xl skeleton-w-lg" }),
        React.createElement("li", { className: "skeleton-line skeleton-h-xl skeleton-w-md mt-0 ml-5" }),
        React.createElement("li", { className: "skeleton-line skeleton-h-xl skeleton-w-xl mt-0 ml-5" })),
    React.createElement("div", { className: "tab-content w-100" },
        React.createElement("span", { className: "skeleton-line skeleton-h-md" }),
        React.createElement("span", { className: "skeleton-line skeleton-h-md" }),
        React.createElement("span", { className: "skeleton-line skeleton-h-md w-75" })))); };
export default React.memo(TabsSkeleton);
